// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Share: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 11 11"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M8.25 4.75a2.25 2.25 0 10-2.234-1.971L3.811 3.88a2.25 2.25 0 100 3.24L6.016 8.22a2.25 2.25 0 10.673-1.34L4.484 5.778c.011-.091.016-.183.016-.279 0-.096-.005-.188-.016-.279L6.689 4.12c.403.39.954.63 1.561.63z" />
        </svg>
    );
};

export default React.memo(Share);
